import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Button, Row, Col, Card } from 'react-bootstrap';
import SidebarDashboard from './SidebarDashboard';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';

const NavigationMembre = () => {

  const currentYear = new Date().getFullYear(); // Renvoie automatiquement 2026, puis 2027, etc.  

  return (
    <React.Fragment>
      <Container fluid className='min-vh-100 text-light py-4 mt-2 my-0'>
        <div className="d-flex flex-column flex-md-row">
          <SidebarDashboard />
          <div className="admin-main-wrapper w-100">
            <Container className="py-2 bg-profil min-vh-100">
              <XyzTransition appear xyz='fade stagger delay-4 duration-15'>
                <Container className="py-1 my-md-5">
                  <Row className="justify-content-center">
                    <Col md={10} lg={8}>

                      {/* Card principale effet "Verre" pour un look moderne */}
                      <Card className="shadow-lg border-secondary text-center p-2 bg-dark bg-dashboard text-white rounded-4">
                        <Card.Body className="profile-body">

                          {/* Titre Principal */}
                          <Card.Title as="h1" className="fw-extrabold mb-3 text-warning">
                            <span className="d-inline-block p-2 border border-secondary rounded-4 shadow-sm fs-2">
                              <span>📌</span> Tableau de bord
                            </span>
                          </Card.Title>

                          {/* Paragraphe d'accueil */}
                          <Card.Text className="text-secondary-emphasis fs-5 mb-3 mx-auto" style={{ maxWidth: '700px' }}>
                            Vous êtes sur votre tableau de bord afin de consulter votre profil et ajouter vos notes personnelles.<br />
                            Un agenda est aussi à votre disposition incluant tous vos rendez-vous.
                          </Card.Text>

                          {/* SECTION BOUTONS D'ACTION */}
                          <Row className="g-3 justify-content-center mb-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
                            <Col xs={12} sm={4}>
                              <Button
                                as={NavLink}
                                to="/utilisateur/profile"
                                variant="outline-primary"
                                className="w-100 px-2 fw-semibold d-flex align-items-center justify-content-center gap-2 rounded-3 text-white border-secondary-emphasis shadow"
                              >
                                <i className="bi bi-person-fill fs-5 "></i>Mon Profil
                              </Button>
                            </Col>
                            <Col xs={12} sm={4}>
                              <Button
                                as={NavLink}
                                to="/utilisateur/calendar"
                                variant="outline-primary"
                                className="w-100 px-2 fw-semibold d-flex align-items-center justify-content-center gap-2 rounded-3 text-white border-secondary-emphasis shadow"
                              >
                                <i className="bi bi-calendar3 fs-5"></i>Mon Agenda
                              </Button>
                            </Col>
                            <Col xs={12} sm={4}>
                              <Button
                                as={NavLink}
                                to="/utilisateur/note"
                                variant="outline-primary"
                                className="w-100 px-2 fw-semibold d-flex align-items-center justify-content-center gap-2 rounded-3 text-white border-secondary-emphasis shadow"
                              >
                                <i className="bi bi-file-earmark-text-fill fs-5"></i>Mes Notes
                              </Button>
                            </Col>
                          </Row>


                          {/* Zone d'alerte de Confidentialité */}
                          <div className="bg-light bg-opacity-10 border border-success border-opacity-25 rounded-4 p-2 mb-5 d-flex justify-content-center">
                            <div>
                              <h3 className="text-info fw-semibold mb-2 uppercase tracking-wide small">
                                Confidentialité Garantie
                              </h3>
                              <i className="bi bi-shield-check text-warning fs-3 mx-2 mb-2 lh-1"></i>
                              <p className="text-center text-light lh-base">
                                Vos informations concernant votre profil ainsi que vos notes enregistrées sont et resteront
                                <strong className="text-white"> strictement confidentielles </strong>
                                selon les conditions générales d'utilisation.
                              </p>
                            </div>
                          </div>

                          {/* Mot de fin et Signature */}
                          <div className="pt-4 border-top border-secondary">
                            <p className="fs-6 mb-2 d-flex align-items-center justify-content-center gap-2">
                              <i className="bi bi-heart-fill text-danger animate-pulse"></i>
                              Je vous souhaite un agréable moment passé en compagnie de Memento
                              <i className="bi bi-heart-fill text-danger animate-pulse"></i>
                            </p>
                            <small className="text-light d-block mt-3 font-monospace">
                              &copy; {currentYear} Memento
                            </small>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </XyzTransition>
            </Container>
          </div>
        </div>
      </Container>
    </React.Fragment>

  )
};

export default NavigationMembre;